import { XMLBuilder, XMLParser } from 'fast-xml-parser'

import type { Edge } from './edge'
import type { Node } from './node'

export interface Data {
  nodes: readonly Node[]
  edges: readonly Edge[]
}
export namespace Data {
  /**
   * Encodes {@link Data} as XML
   *
   * @see {@link fromXml}, {@link toJson}
   */
  export function toXml(
    data: Data,
    { format = false }: EncodingOptions = {},
  ): string {
    const xmlBuilder = new XMLBuilder({ format })
    return xmlBuilder.build(data)
  }
  /**
   * Decodes XML to {@link Data}
   *
   * @see {@link toXml}, {@link fromJson}
   */
  export function fromXml(xml: string): Data {
    const xmlParser = new XMLParser()
    return xmlParser.parse(xml)
  }
  /**
   * Encodes {@link Data} as JSON
   *
   * @see {@link fromXml}, {@link toJson}
   */
  export function toJson(
    data: Data,
    { format = false }: EncodingOptions = {},
  ): string {
    return JSON.stringify(data, null, format ? 2 : undefined)
  }
  /**
   * Decodes JSON to {@link Data}
   *
   * @see {@link toJson}, {@link fromXml}
   */
  export function fromJson(json: string): Data {
    return JSON.parse(json)
  }

  export interface EncodingOptions {
    /**
     * Set to `true` to make the results more readable
     *
     * @default false
     */
    format?: boolean
  }
}
